import 'array.prototype.upsert'
import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import store from './store'
import { apolloProvider } from './graphql/apollo'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import VueGoogleCharts from 'vue-google-charts'
import VueCountdown from '@chenfengyuan/vue-countdown';

// Import the styles directly. (Or you could add them via script tags.)
// import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import router from './routes/routes'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import sidebarLinks from './sidebarLinks'
import Select2 from 'v-select2-component';

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(BootstrapVue);
Vue.use(VueGoogleCharts)
Vue.component(VueCountdown.name, VueCountdown)
Vue.component('select2', Select2);
locale.use(lang)

/* eslint-disable no-new */
const vue = new Vue({
  store,
  apolloProvider,
  el: '#app',
  render: h => h(App),
  router
})




// WEBPACK FOOTER //
// ./src/main.js